<template>
  <div class="box">
    <van-overlay :show="show">
      <div class="wrapper">
        <van-loading color="#0094ff"
                     text-color="#0094ff"
                     size="24px"
                     vertical>问卷加载中...</van-loading>
      </div>
    </van-overlay>
    <div class='vote_detail'
         v-if="!is_done">
      <div class="title"
           v-if="!show">
        <h1>{{voteData.title}}</h1>
        <div style="color: rgb(111, 110, 110);">星圈友情提醒：本次问卷为{{voteData.is_anonymous ? '匿名':'实名'}}问卷</div>
      </div>
      <van-image width="100%"
                 height="100%"
                 v-if="voteData.img_url !== ''"
                 :src="voteData.img_url" />
      <div class="describe">
        {{voteData.desc}}
      </div>
      <div class=" content"
           v-for="(item, index) in voteData.questions"
           :key="item.question_id">
        <RADIOPAGE @UpskipQuestionId="UpskipQuestionId"
                   :ref="'questionnaire'+index"
                   v-if="+item.topic_id === 1"
                   v-show="ifShowQuestion(item)"
                   v-bind="item"
                   :index='index'
                   :is_done='is_done' />
        <MULTISELECTPAGE @UpskipQuestionId="UpskipQuestionId"
                         :ref="'questionnaire'+index"
                         v-else-if="+item.topic_id === 2"
                         v-show="ifShowQuestion(item)"
                         v-bind="item"
                         :index='index'
                         :is_done='is_done' />
        <VOTEGRADE @UpskipQuestionId="UpskipQuestionId"
                   :ref="'questionnaire'+index"
                   v-else-if='+item.topic_id === 5'
                   v-show="ifShowQuestion(item)"
                   v-bind="item"
                   :index='index'
                   :is_done='is_done' />
        <VOTEINPUT @UpskipQuestionId="UpskipQuestionId"
                   :ref="'questionnaire'+index"
                   v-else-if="+item.topic_id === 4 || +item.topic_id === 3"
                   v-show="ifShowQuestion(item)"
                   v-bind="item"
                   :index='index'
                   :is_done='is_done' />
        <MATRIXPAGE v-else-if="+item.topic_id === 6"
                    @UpskipQuestionId="UpskipQuestionId"
                    :ref="'questionnaire'+index"
                    v-show="ifShowQuestion(item)"
                    v-bind="item"
                    :index='index'
                    :is_done='is_done' />
      </div>
    </div>
    <!-- <div class="anonymity">
          <div>是否匿名</div>
          <van-switch v-model="isCryptonym" size="24" />
        </div> -->
    <!-- <van-cell center title="是否匿名">
          <template #right-icon>
            <van-switch v-model="isCryptonym" size="24" />
          </template>
        </van-cell> -->
    <div class="btn">
      <van-button style="margin-right:10px"
                  v-show="!is_done"
                  type="primary"
                  block
                  @click="subQuestionnaire">提交</van-button>
      <!-- <van-button v-show="!is_done" type="primary" block @click="subQuestionnaire">匿名提交</van-button> -->
    </div>
    <div class="support">
      该问卷由
      <img class="logo"
           src="../../../assets/images/questionnaire/que_logo.jpg">
      <span class="department">星圈</span>
      提供技术支持
    </div>
  </div>
</template>

<script>
import RADIOPAGE from './components/radioPage.vue'
import MULTISELECTPAGE from './components/multiSelectPage.vue'
import VOTEGRADE from './components/VoteGrade.vue'
import VOTEINPUT from './components/voteInput.vue'
import MATRIXPAGE from './components/matrixPage.vue'
import { submitQuestionnaire } from '@/api/api'
import { get as getUser } from '../../../utils/token'
import dd from 'DD'
export default {
  components: {
    RADIOPAGE,
    MULTISELECTPAGE,
    VOTEGRADE,
    VOTEINPUT,
    MATRIXPAGE
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from.path
    })
  },
  data () {
    return {
      show: false,
      text: '',
      voteData: '',
      mobile: getUser('mobile'),
      is_done: false,
      skipQuestionIdArr: [],
      skipQuestionIdInit: [],
      ID: {},
      isCryptonym: false,
      prevRoute: ''
    }
  },
  async mounted () {
    if (!this.$route.query.questionnaire_id) {
      this.$toast.fail('问卷不存在  即将跳转首页')
      setTimeout(() => {
        this.$router.push({ path: '/exerland/bbs/find' })
      }, 1000)
      return
    }
    await this.getVoteIsDone()
    if (!this.is_done) {
      this.getVoteDetail()
    }
  },
  methods: {
    upUvdata () {
      const user = getUser('user')
      this.$API.upUvData({
        user: user.id,
        path: `/exerland/questionnaireDetail?questionnaire_id=${this.$route.query.questionnaire_id}`,
        location: `问卷详情-${this.$route.query.questionnaire_id}`,
        tracking_type: 7
      })
    },
    // 查询用户是否填写该问卷
    async getVoteIsDone () {
      const data = await this.$API.getVoteIsDone(this.mobile, this.$route.query.questionnaire_id)
      if (data.code === 200) {
        this.is_done = data.data.is_done
        if (this.is_done) {
          this.$dialog.alert({
            message: '谢谢您的参与，您已提交本次问卷。',
            theme: 'round-button',
            confirmButtonColor: '#19cca0'
          }).then(() => {
            // console.log(this.prevRoute)
            if (this.prevRoute === '/') {
              if (dd.env.platform !== 'notInDingTalk') {
                dd.biz.navigation.quit({})
              } else {
                window.opener = null
                window.open('', '_self')
                window.close()
              }
            } else {
              this.$router.go(-1)
            }
          })
        }
      }
    },
    async subQuestionnaire () {
      const result = this.upQuestionnaireData()
      if (!result) return
      const data = await submitQuestionnaire(this.mobile, result)
      if (data.code === 200) {
        this.$toast.success('问卷提交成功')
        this.$API.setVoteDone({
          mobile: this.mobile,
          questionnaire_id: this.voteData.questionnaire_id,
          isCryptonym: this.isCryptonym
        })
        setTimeout(() => {
          this.$router.push({ path: '/exerland/questionnaireList', query: { isUp: true } })
        }, 1000)
      } else {
        this.$toast.fail('问卷提交失败')
      }
    },
    upQuestionnaireData () {
      const arr = []
      const result = JSON.parse(JSON.stringify(this.voteData))
      for (let i = 0; i < result.questions.length; i++) {
        if (this.$refs['questionnaire' + i]) {
          if (!this.$refs['questionnaire' + i][0].isWrite) {
            this.$toast.fail('问卷存在未填写的必填项')
            return false
          }
          arr.push(this.$refs['questionnaire' + i][0].questionData)
        }
      }
      result.questions = arr
      return result
    },
    UpskipQuestionId (OBJ) {
      const arr = []
      this.skipQuestionIdArr = [...this.skipQuestionIdInit]
      for (const key in OBJ) {
        this.ID[key] = [...OBJ[key]]
      }
      for (const key in this.ID) {
        arr.push(...this.ID[key])
      }
      arr.forEach(item => {
        const index = this.skipQuestionIdArr.indexOf(+item)
        if (index !== -1) {
          this.skipQuestionIdArr.splice(index, 1)
        }
      })
    },
    ifShowQuestion (item) {
      if (this.is_done) {
        if (item.topic_id === 6) {
          if (item.options.matrix_answers.length !== 0) {
            return true
          } else {
            return false
          }
        } else {
          if (item.options[0].answer !== null) {
            return true
          } else {
            return false
          }
        }
      } else {
        if (this.skipQuestionIdArr.indexOf(item.question_id) !== -1) {
          return false
        }
        return true
      }
    },
    disposeSkipQuestionId (data) {
      let idArr = []
      for (const i in data) {
        if (JSON.stringify(data[i].jump_rules) !== '{}') {
          const jumpRules = data[i].jump_rules
          for (const j in jumpRules) {
            jumpRules[j].forEach(item => {
              idArr.push(item.next_question_id)
            })
          }
        }
      }
      idArr = [...new Set(idArr)]
      this.skipQuestionIdArr = [...idArr]
      this.skipQuestionIdInit = [...idArr]
    },
    async getVoteDetail () {
      try {
        this.show = true
        const data = await this.$API.getVoteDetail(this.$route.query.questionnaire_id, this.mobile)
        if (data.code === 200) {
          this.disposeSkipQuestionId(data.data.questions)
          this.voteData = data.data
          this.show = false
        }
      } catch (error) {

      }
    },

    toggle (index) {
      (this.result.indexOf(this.list[index]) > -1) ? this.result.splice(this.result.indexOf(this.list[index]), 1) : this.result.push(this.list[index])
    }
  }
}
</script>

<style lang='scss' scoped>
.anonymity {
  display: flex;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  background-color: aquamarine;
  border-radius: 12px;
  margin: 10px 0;
}
.box {
  width: 91.17%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  margin: 0 auto;
  .support {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #f9f9f9;
    color: #6c6f73;
    text-align: center;
    font-size: 12px;
    .logo {
      width: 15px;
      height: 15px;
      vertical-align: middle;
    }
    .department {
      color: #000;
      margin-left: 5px;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .vote_detail {
  }
  .title {
    font-size: 10px;
    margin: 20px auto;
    text-align: center;
  }
  .content {
    // overflow-y: auto;
    .multiple_choice {
      .img-icon {
        height: 20px;
      }
    }
  }
  .content {
    margin: 20px auto;
  }
  .btn {
    margin-bottom: 10px;
    display: flex;
  }
}
.option_box {
  .van-cell {
    width: 91.17%;
    // border: 1px solid #ebedf0;
  }
}
</style>
